module.exports = __webpack_public_path__ + "static/media/Firefighter.5e513aea.jpg";